// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  color: #333;
}

/* Main Container */
.label-printing-system {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
}

/* Header */
.system-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.system-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 10px;
  text-align: center;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.current-roll {
  text-align: center;
  font-size: 1.2rem;
  color: #4a5568;
  font-weight: 500;
}

/* Navigation Tabs */
.nav-tabs {
  display: flex;
  gap: 5px;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.1);
  padding: 8px;
  border-radius: 15px;
  backdrop-filter: blur(10px);
}

.nav-tab {
  flex: 1 1;
  padding: 15px 20px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.nav-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transform: translateY(-2px);
}

.nav-tab.active {
  background: white;
  color: #667eea;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Content Container */
.content-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: 500px;
}

/* Section Titles */
.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 25px;
  padding-bottom: 12px;
  border-bottom: 3px solid #667eea;
  display: inline-block;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 2px;
}

/* Form Styles */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #4a5568;
  font-size: 1rem;
}

.form-input,
.form-select {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
  color: #4a5568;
  font-weight: 500;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.form-input::placeholder,
.form-select::placeholder {
  color: #a0aec0;
  font-style: italic;
  font-weight: 400;
}

.form-help {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 5px;
  line-height: 1.4;
}

/* Button Styles */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
}

.btn-secondary:hover {
  background: #edf2f7;
  transform: translateY(-1px);
}

.btn-success {
  background: linear-gradient(135deg, #48bb78, #38a169);
  color: white;
  box-shadow: 0 5px 15px rgba(72, 187, 120, 0.3);
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(72, 187, 120, 0.4);
}

.btn-danger {
  background: linear-gradient(135deg, #f56565, #e53e3e);
  color: white;
  box-shadow: 0 5px 15px rgba(245, 101, 101, 0.3);
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(245, 101, 101, 0.4);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

/* Grid Layout */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.form-row {
  display: flex;
  gap: 15px;
  align-items: end;
}

/* Cards */
.card {
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

/* Tables */
.table-container {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 15px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table td {
  padding: 15px;
  border-bottom: 1px solid #e2e8f0;
  color: #4a5568;
}

.table tbody tr:hover {
  background: #f7fafc;
}

.table tbody tr:last-child td {
  border-bottom: none;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
}

.action-buttons .btn-icon {
  padding: 8px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  min-width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.action-buttons .btn-icon:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-edit {
  background: #bee3f8;
  color: #2b6cb0;
}

.btn-edit:hover {
  background: #90cdf4;
  transform: scale(1.1);
}

.btn-delete {
  background: #fed7d7;
  color: #c53030;
}

.btn-delete:hover {
  background: #feb2b2;
  transform: scale(1.1);
}

.btn-insert {
  background: #c6f6d5;
  color: #22543d;
}

.btn-insert:hover {
  background: #9ae6b4;
  transform: scale(1.1);
}

.row-actions {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.row-actions .btn-icon {
  padding: 8px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  min-width: 32px;
  height: 32px;
}

.btn-insert {
  background: linear-gradient(135deg, #c6f6d5, #9ae6b4);
  color: #22543d;
  border: 2px solid #9ae6b4;
}

.btn-insert:hover {
  background: linear-gradient(135deg, #9ae6b4, #68d391);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
}

.btn-delete {
  background: linear-gradient(135deg, #fed7d7, #feb2b2);
  color: #c53030;
  border: 2px solid #feb2b2;
}

.btn-delete:hover {
  background: linear-gradient(135deg, #feb2b2, #fc8181);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.3);
}

.btn-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.clickable-cell {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clickable-cell:hover {
  background-color: #f7fafc;
}

.collated-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.select-all-container {
  display: flex;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.3s ease;
}

.checkbox-label:hover {
  color: #667eea;
}

.checkbox-input {
  width: 18px;
  height: 18px;
  border: 2px solid #e2e8f0;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.checkbox-input:checked {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.checkbox-input:checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.checkbox-input:hover {
  border-color: #667eea;
  transform: scale(1.05);
}

.checkbox-text {
  font-size: 0.95rem;
  font-weight: 500;
}

.collated-controls .btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-weight: 500;
}

.collated-controls .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mtr-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border: 2px solid #e2e8f0;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.add-remove-controls {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-danger {
  background: linear-gradient(135deg, #fed7d7, #feb2b2);
  color: #c53030;
  border: 2px solid #feb2b2;
  font-weight: 600;
}

.btn-danger:hover {
  background: linear-gradient(135deg, #feb2b2, #fc8181);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 101, 101, 0.3);
}

.btn-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* MTR Table Styles */
.mtr-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.mtr-table th {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 16px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.mtr-table th:last-child {
  border-right: none;
}

.mtr-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  color: #4a5568;
  vertical-align: middle;
  border-right: 1px solid #f1f5f9;
}

.mtr-table td:last-child {
  border-right: none;
}

.mtr-table tr:hover {
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.mtr-table tr:last-child td {
  border-bottom: none;
}

.mtr-input {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: white;
  color: #4a5568;
}

.mtr-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}

.mtr-input::placeholder {
  color: #a0aec0;
  font-style: italic;
}

.mtr-input:invalid {
  border-color: #f56565;
  box-shadow: 0 0 0 3px rgba(245, 101, 101, 0.1);
}

/* MTR Summary and Actions */
.mtr-summary {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border: 1px solid #e2e8f0;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.summary-chip {
  background: white;
  border: 2px solid #e2e8f0;
  padding: 8px 16px;
  border-radius: 25px;
  font-size: 0.95rem;
  color: #4a5568;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.summary-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
}

/* Filter Section Styles */
.filter-section {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 25px;
  border: 1px solid #e2e8f0;
}

.filter-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: flex-end;
}

/* Report Section Styles */
.report-section {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  border: 1px solid #e2e8f0;
}

.section-subtitle {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid #667eea;
  display: inline-block;
}

.report-type-selection {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.report-type-btn {
  flex: 1 1;
  padding: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background: white;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 1rem;
}

.report-type-btn:hover {
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.1);
}

.report-type-btn.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-color: #667eea;
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.report-actions {
  display: flex;
  gap: 15px;
  margin-top: 20px;
  justify-content: flex-start;
}

.report-summary {
  background: white;
  border-radius: 10px;
  padding: 15px 20px;
  margin-top: 20px;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.report-summary p {
  font-weight: 600;
  color: #4a5568;
  margin: 0;
}

/* History Log Styles */
.history-log-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.date-group {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

.date-header {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 15px 20px;
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
}

/* Clickable Rows */
.clickable-row {
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.clickable-row:hover {
  background: #f0f4ff !important;
}

.clickable-cell {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clickable-cell:hover {
  background-color: #f7fafc;
}

/* History Modal */
.history-modal {
  max-width: 800px;
  width: 90%;
}

.history-modal .table-container {
  max-height: 400px;
  overflow-y: auto;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 20px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e2e8f0;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #a0aec0;
  padding: 5px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.modal-close:hover {
  color: #4a5568;
  background: #f7fafc;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #a0aec0;
}

.empty-state-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-state-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: #4a5568;
}

.empty-state-text {
  font-size: 1rem;
  margin-bottom: 25px;
}

/* Loading Animation */
.loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Print Styles */
.print-only {
  display: none;
}

@media print {
  .no-print {
    display: none !important;
  }
  
  .print-only {
    display: block !important;
  }
  
  body {
    margin: 0;
    padding: 0;
    background: white;
  }
  
  .label-grid {
    page-break-inside: avoid;
  }
}

/* GP print-safe styles ----------------------------------------------- */
@page {
  size: A4;
  margin: 15mm 8mm 10mm 8mm; /* top right bottom left — top is the important one */
}
@media print {
  html, body {
    height: 297mm;
  }
  .gp-page {
    box-sizing: border-box;
    width: 210mm;
    min-height: 297mm;
    padding: 15mm 8mm 10mm 8mm; /* match @page margins to ensure content inside safe area */
  }
  /* ensure header draws inside safe area */
  .gp-header {
    position: relative; /* avoid absolute top:0 which can be clipped */
    margin-bottom: 6mm;
  }
  /* ensure top border sits inside padding */
  .gp-top-border {
    border-top: 1px solid #000;
    padding-top: 2mm;
  }
}
/* end GP print-safe styles ------------------------------------------- */

/* Search Section Styles */
.search-section {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border: 1px solid #e2e8f0;
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.search-container {
  display: flex;
  justify-content: center;
}

.search-input-group {
  display: flex;
  gap: 12px;
  align-items: center;
  max-width: 600px;
  width: 100%;
}

.search-input {
  flex: 1 1;
  padding: 14px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
  color: #4a5568;
  font-weight: 500;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.search-input::placeholder {
  color: #a0aec0;
  font-style: italic;
  font-weight: 400;
}

.search-btn {
  padding: 14px 24px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.search-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.clear-btn {
  padding: 14px 20px;
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.clear-btn:hover {
  background: #edf2f7;
  transform: translateY(-1px);
}

/* Search Results Section */
.search-results-section {
  background: white;
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

.roll-number-cell {
  font-weight: 600;
  color: #667eea;
  background: linear-gradient(135deg, #f0f4ff, #e6f3ff);
  border-radius: 6px;
  padding: 4px 8px;
  display: inline-block;
  min-width: 60px;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .label-printing-system {
    padding: 10px;
  }
  
  .system-header {
    padding: 20px;
  }
  
  .system-title {
    font-size: 2rem;
  }
  
  .nav-tab {
    padding: 12px 16px;
  }
  
  .content-container {
    padding: 20px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .form-row {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .quantity-grid {
    grid-template-columns: 1fr;
  }
  
  .modal {
    margin: 10px;
    width: calc(100% - 20px);
  }
  
  .report-type-selection {
    flex-direction: column;
    gap: 10px;
  }
  
  .report-type-btn {
    padding: 15px;
    flex-direction: row;
    justify-content: center;
  }
  
  .report-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .report-section {
    padding: 20px;
  }
  
  .summary-header {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .summary-totals {
    flex-direction: column;
    gap: 10px;
  }
  
  .summary-totals span {
    text-align: center;
  }
  
  .search-input-group {
    flex-direction: column;
    gap: 10px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .search-btn, .clear-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Success/Error Messages */
.alert {
  padding: 15px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  font-weight: 500;
}

.alert-success {
  background: #c6f6d5;
  color: #22543d;
  border: 1px solid #9ae6b4;
}

.alert-error {
  background: #fed7d7;
  color: #742a2a;
  border: 1px solid #feb2b2;
}

.alert-info {
  background: #bee3f8;
  color: #2a4365;
  border: 1px solid #90cdf4;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,6DAA6D;EAC7D,iBAAiB;EACjB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yEAAyE;AACzE;EACE,QAAQ;EACR,yBAAyB,EAAE,qDAAqD;AAClF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,0BAA0B,EAAE,2DAA2D;EACzF;EACA,yCAAyC;EACzC;IACE,kBAAkB,EAAE,8CAA8C;IAClE,kBAAkB;EACpB;EACA,0CAA0C;EAC1C;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;AACA,yEAAyE;;AAEzE,0BAA0B;AAC1B;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* Global Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: 100vh;\n  color: #333;\n}\n\n/* Main Container */\n.label-printing-system {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 100vh;\n}\n\n/* Header */\n.system-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.system-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 10px;\n  text-align: center;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.current-roll {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n/* Navigation Tabs */\n.nav-tabs {\n  display: flex;\n  gap: 5px;\n  margin-bottom: 30px;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 8px;\n  border-radius: 15px;\n  backdrop-filter: blur(10px);\n}\n\n.nav-tab {\n  flex: 1;\n  padding: 15px 20px;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.8);\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.nav-tab:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  transform: translateY(-2px);\n}\n\n.nav-tab.active {\n  background: white;\n  color: #667eea;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Content Container */\n.content-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  min-height: 500px;\n}\n\n/* Section Titles */\n.section-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 25px;\n  padding-bottom: 12px;\n  border-bottom: 3px solid #667eea;\n  display: inline-block;\n  position: relative;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-radius: 2px;\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #4a5568;\n  font-size: 1rem;\n}\n\n.form-input,\n.form-select {\n  width: 100%;\n  padding: 14px 18px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: white;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);\n  transform: translateY(-2px);\n}\n\n.form-input::placeholder,\n.form-select::placeholder {\n  color: #a0aec0;\n  font-style: italic;\n  font-weight: 400;\n}\n\n.form-help {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-top: 5px;\n  line-height: 1.4;\n}\n\n/* Button Styles */\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.btn-secondary {\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n}\n\n.btn-secondary:hover {\n  background: #edf2f7;\n  transform: translateY(-1px);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #48bb78, #38a169);\n  color: white;\n  box-shadow: 0 5px 15px rgba(72, 187, 120, 0.3);\n}\n\n.btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(72, 187, 120, 0.4);\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #f56565, #e53e3e);\n  color: white;\n  box-shadow: 0 5px 15px rgba(245, 101, 101, 0.3);\n}\n\n.btn-danger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(245, 101, 101, 0.4);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* Grid Layout */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.form-row {\n  display: flex;\n  gap: 15px;\n  align-items: end;\n}\n\n/* Cards */\n.card {\n  background: white;\n  border-radius: 15px;\n  padding: 20px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n}\n\n/* Tables */\n.table-container {\n  background: white;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  margin-bottom: 20px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  padding: 15px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.table td {\n  padding: 15px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #4a5568;\n}\n\n.table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-buttons .btn-icon {\n  padding: 8px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  min-width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n}\n\n.action-buttons .btn-icon:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-edit {\n  background: #bee3f8;\n  color: #2b6cb0;\n}\n\n.btn-edit:hover {\n  background: #90cdf4;\n  transform: scale(1.1);\n}\n\n.btn-delete {\n  background: #fed7d7;\n  color: #c53030;\n}\n\n.btn-delete:hover {\n  background: #feb2b2;\n  transform: scale(1.1);\n}\n\n.btn-insert {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.btn-insert:hover {\n  background: #9ae6b4;\n  transform: scale(1.1);\n}\n\n.row-actions {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.row-actions .btn-icon {\n  padding: 8px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  min-width: 32px;\n  height: 32px;\n}\n\n.btn-insert {\n  background: linear-gradient(135deg, #c6f6d5, #9ae6b4);\n  color: #22543d;\n  border: 2px solid #9ae6b4;\n}\n\n.btn-insert:hover {\n  background: linear-gradient(135deg, #9ae6b4, #68d391);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);\n}\n\n.btn-delete {\n  background: linear-gradient(135deg, #fed7d7, #feb2b2);\n  color: #c53030;\n  border: 2px solid #feb2b2;\n}\n\n.btn-delete:hover {\n  background: linear-gradient(135deg, #feb2b2, #fc8181);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.3);\n}\n\n.btn-delete:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.clickable-cell {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.clickable-cell:hover {\n  background-color: #f7fafc;\n}\n\n.collated-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n}\n\n.select-all-container {\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #4a5568;\n  transition: all 0.3s ease;\n}\n\n.checkbox-label:hover {\n  color: #667eea;\n}\n\n.checkbox-input {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #e2e8f0;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.checkbox-input:checked {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.checkbox-input:checked::after {\n  content: '✓';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkbox-input:hover {\n  border-color: #667eea;\n  transform: scale(1.05);\n}\n\n.checkbox-text {\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.collated-controls .btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n}\n\n.collated-controls .btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.mtr-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\n  border: 2px solid #e2e8f0;\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.add-remove-controls {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #fed7d7, #feb2b2);\n  color: #c53030;\n  border: 2px solid #feb2b2;\n  font-weight: 600;\n}\n\n.btn-danger:hover {\n  background: linear-gradient(135deg, #feb2b2, #fc8181);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(245, 101, 101, 0.3);\n}\n\n.btn-danger:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* MTR Table Styles */\n.mtr-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  background: white;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.mtr-table th {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  padding: 16px 20px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mtr-table th:last-child {\n  border-right: none;\n}\n\n.mtr-table td {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #4a5568;\n  vertical-align: middle;\n  border-right: 1px solid #f1f5f9;\n}\n\n.mtr-table td:last-child {\n  border-right: none;\n}\n\n.mtr-table tr:hover {\n  background: #f8fafc;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.mtr-table tr:last-child td {\n  border-bottom: none;\n}\n\n.mtr-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background: white;\n  color: #4a5568;\n}\n\n.mtr-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n  transform: translateY(-1px);\n}\n\n.mtr-input::placeholder {\n  color: #a0aec0;\n  font-style: italic;\n}\n\n.mtr-input:invalid {\n  border-color: #f56565;\n  box-shadow: 0 0 0 3px rgba(245, 101, 101, 0.1);\n}\n\n/* MTR Summary and Actions */\n.mtr-summary {\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\n  border: 1px solid #e2e8f0;\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: center;\n}\n\n.summary-chip {\n  background: white;\n  border: 2px solid #e2e8f0;\n  padding: 8px 16px;\n  border-radius: 25px;\n  font-size: 0.95rem;\n  color: #4a5568;\n  font-weight: 500;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.summary-chip:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #667eea;\n}\n\n.form-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n/* Filter Section Styles */\n.filter-section {\n  background: #f8f9fa;\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 25px;\n  border: 1px solid #e2e8f0;\n}\n\n.filter-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n  justify-content: flex-end;\n}\n\n/* Report Section Styles */\n.report-section {\n  background: #f8f9fa;\n  border-radius: 15px;\n  padding: 25px;\n  margin-bottom: 25px;\n  border: 1px solid #e2e8f0;\n}\n\n.section-subtitle {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 20px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #667eea;\n  display: inline-block;\n}\n\n.report-type-selection {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.report-type-btn {\n  flex: 1;\n  padding: 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.report-type-btn:hover {\n  border-color: #667eea;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.1);\n}\n\n.report-type-btn.active {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  border-color: #667eea;\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n.report-actions {\n  display: flex;\n  gap: 15px;\n  margin-top: 20px;\n  justify-content: flex-start;\n}\n\n.report-summary {\n  background: white;\n  border-radius: 10px;\n  padding: 15px 20px;\n  margin-top: 20px;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n}\n\n.report-summary p {\n  font-weight: 600;\n  color: #4a5568;\n  margin: 0;\n}\n\n/* History Log Styles */\n.history-log-container {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.date-group {\n  background: white;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e2e8f0;\n}\n\n.date-header {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  padding: 15px 20px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Clickable Rows */\n.clickable-row {\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.clickable-row:hover {\n  background: #f0f4ff !important;\n}\n\n.clickable-cell {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.clickable-cell:hover {\n  background-color: #f7fafc;\n}\n\n/* History Modal */\n.history-modal {\n  max-width: 800px;\n  width: 90%;\n}\n\n.history-modal .table-container {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.modal-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #a0aec0;\n  padding: 5px;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n\n.modal-close:hover {\n  color: #4a5568;\n  background: #f7fafc;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 25px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #a0aec0;\n}\n\n.empty-state-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n\n.empty-state-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #4a5568;\n}\n\n.empty-state-text {\n  font-size: 1rem;\n  margin-bottom: 25px;\n}\n\n/* Loading Animation */\n.loading {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Print Styles */\n.print-only {\n  display: none;\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .print-only {\n    display: block !important;\n  }\n  \n  body {\n    margin: 0;\n    padding: 0;\n    background: white;\n  }\n  \n  .label-grid {\n    page-break-inside: avoid;\n  }\n}\n\n/* GP print-safe styles ----------------------------------------------- */\n@page {\n  size: A4;\n  margin: 15mm 8mm 10mm 8mm; /* top right bottom left — top is the important one */\n}\n@media print {\n  html, body {\n    height: 297mm;\n  }\n  .gp-page {\n    box-sizing: border-box;\n    width: 210mm;\n    min-height: 297mm;\n    padding: 15mm 8mm 10mm 8mm; /* match @page margins to ensure content inside safe area */\n  }\n  /* ensure header draws inside safe area */\n  .gp-header {\n    position: relative; /* avoid absolute top:0 which can be clipped */\n    margin-bottom: 6mm;\n  }\n  /* ensure top border sits inside padding */\n  .gp-top-border {\n    border-top: 1px solid #000;\n    padding-top: 2mm;\n  }\n}\n/* end GP print-safe styles ------------------------------------------- */\n\n/* Search Section Styles */\n.search-section {\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\n  border: 1px solid #e2e8f0;\n  border-radius: 15px;\n  padding: 25px;\n  margin-bottom: 25px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.search-container {\n  display: flex;\n  justify-content: center;\n}\n\n.search-input-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  max-width: 600px;\n  width: 100%;\n}\n\n.search-input {\n  flex: 1;\n  padding: 14px 18px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: white;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);\n  transform: translateY(-2px);\n}\n\n.search-input::placeholder {\n  color: #a0aec0;\n  font-style: italic;\n  font-weight: 400;\n}\n\n.search-btn {\n  padding: 14px 24px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n.search-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.search-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.clear-btn {\n  padding: 14px 20px;\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.clear-btn:hover {\n  background: #edf2f7;\n  transform: translateY(-1px);\n}\n\n/* Search Results Section */\n.search-results-section {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  margin-bottom: 25px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e2e8f0;\n}\n\n.roll-number-cell {\n  font-weight: 600;\n  color: #667eea;\n  background: linear-gradient(135deg, #f0f4ff, #e6f3ff);\n  border-radius: 6px;\n  padding: 4px 8px;\n  display: inline-block;\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .label-printing-system {\n    padding: 10px;\n  }\n  \n  .system-header {\n    padding: 20px;\n  }\n  \n  .system-title {\n    font-size: 2rem;\n  }\n  \n  .nav-tab {\n    padding: 12px 16px;\n  }\n  \n  .content-container {\n    padding: 20px;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .quantity-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .modal {\n    margin: 10px;\n    width: calc(100% - 20px);\n  }\n  \n  .report-type-selection {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .report-type-btn {\n    padding: 15px;\n    flex-direction: row;\n    justify-content: center;\n  }\n  \n  .report-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .report-section {\n    padding: 20px;\n  }\n  \n  .summary-header {\n    flex-direction: column;\n    gap: 10px;\n    text-align: center;\n  }\n  \n  .summary-totals {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .summary-totals span {\n    text-align: center;\n  }\n  \n  .search-input-group {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .search-input {\n    width: 100%;\n  }\n  \n  .search-btn, .clear-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Success/Error Messages */\n.alert {\n  padding: 15px 20px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.alert-success {\n  background: #c6f6d5;\n  color: #22543d;\n  border: 1px solid #9ae6b4;\n}\n\n.alert-error {\n  background: #fed7d7;\n  color: #742a2a;\n  border: 1px solid #feb2b2;\n}\n\n.alert-info {\n  background: #bee3f8;\n  color: #2a4365;\n  border: 1px solid #90cdf4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
